<template>
    <div class="activation commonBackground padding-b">
        <div>
            <common-dialog class="activations" :model-obj="modelObj" :dialog-show="dialogShow" @closeDialog="closeDialog">
                <div slot="title" class="text-center" style="font-size: 1.3em;color:#12ba3e;">
                    恭喜您
                </div>
                <div style="height: 130px;text-align: center;padding-top: 30px;color: #12ba3e; font-size: 1.2em;">
                    激活成功，即将进入系统。。。
                </div>
            </common-dialog>
        </div>
        <el-steps class="registerWrapper" :active="active" align-center>
            <el-step title="填写卡号信息" class="cursorSz" @click.native="active=1" description="">
            </el-step>
            <el-step title="完善账号资料" class="cursorSz" description="" @click.native="active=2">
            </el-step>
        </el-steps>
        <div v-show="active===1">
            <div class="activationTitle m-auto">
                <el-button type="text" style="border-radius: 0; border-bottom: 1px solid #00a1ff;">
                    <div class="left text-l-size" >激活卡激活</div>
                </el-button>
                <el-button type="text" class="margin-medium-left" @click="$router.push('/login/cardBuy')">
                    <div  class="right text-l-size">在线购卡</div>
                </el-button>
            </div>
            <div style="margin-top: 50px;"></div>
            <!--第一步输入卡号-->
            <common-form @goBuy="goBuy" @confirmBind="confirmBind" class="activationTitle m-auto" style="" :fieldList="fieldList" :data="datajh" :rules="rules" :className="className" :labelWidth="labelWidth" :listTypeInfo="listTypeInfo"></common-form>
            <div class="activationTitle m-auto">
                <div class="text-s-size text-default-color">开通高招教育网会员有两种方式:</div>
                <div class="text-s-size text-l-secondary">1.线下购买会员卡，使用激活码在当前页面激活即可</div>
                <div class="text-s-size text-l-secondary">2.点击在线激活，即可进行在线支付购买，支付成功后您的账号将激活为VIP</div>

            </div>
        </div>
        <div v-show="active===2">
            <el-form ref="perfectInfo" :model="perfectData" label-width="90px"
                     :rules="rulesPerfectData" class="page-form secondForm">
                <el-form-item prop="realName" label="真实姓名">
                    <el-input v-model="perfectData.realName" placeholder="请输入真实姓名"></el-input>
                </el-form-item>
                <el-form-item prop="provinceId" label="选择省份">
                    <el-select type="select" placeholder="选择省份" :disabled="provinceDisabled" filterable
                               @change="searchSchoolList" v-model="perfectData.provinceId">
                        <el-option
                                v-for="item in provinceList"
                                :key="item.provinceId"
                                :label="item.provinceName"
                                :value="item.provinceId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="schoolId" label="选择学校">
                    <el-select type="select" placeholder="输入学校名称关键字搜索"  :disabled="perfectData.provinceId===''||schoolDisabled"
                               @change="selectSchoolTap" @click="selectSchool" filterable v-model="perfectData.schoolId">
                        <el-option
                                v-for="item in schoolList"
                                :key="item.schoolId"
                                :label="item.schoolName"
                                :value="item.schoolId">
                        </el-option>
                    </el-select>
                </el-form-item>
<!--                <el-form-item prop="roleId" label="教师角色" v-if="isTeacher">-->
<!--                    <el-select type="select" placeholder="选择角色" v-model="perfectData.roleId">-->
<!--                        <el-option-->
<!--                                v-for="item in roleList"-->
<!--                                :key="item.roleId"-->
<!--                                :label="item.roleName"-->
<!--                                :value="item.roleId">-->
<!--                        </el-option>-->
<!--                    </el-select>-->
<!--                </el-form-item>-->
                <el-form-item prop="gradeId" label="年级" v-show="!isTeacher||perfectData.roleId==='2'||perfectData.roleId==='4'">
                    <el-select type="select" placeholder="选择年级" @change="selectGrade"   v-model="perfectData.gradeId">
                        <el-option
                                v-for="item in gradeList"
                                :key="item.gradeYear"
                                :label="item.gradeName"
                                :value="item.gradeYear">
                        </el-option>
                    </el-select>
                </el-form-item>
                <!--如果查出班级列表为空则不显示，此设置是面向散户的，正常点击激活即可，进入后可以再用户中心选择班级-->
                <el-form-item prop="classId" label="班级" v-show="(!isTeacher||perfectData.roleId==='4')&&classList.length>0">
                    <el-select type="select" placeholder="选择班级"   :disabled="perfectData.gradeId===''||perfectData.schoolId===''" v-model="perfectData.classId">
                        <el-option
                                v-for="item in classList"
                                :key="item.classId"
                                :label="item.className"
                                :value="item.classId">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="教师职位" v-show="isTeacher" prop="roleId">
                    <el-radio-group v-model="perfectData.roleId" @change="tapRadio">
                        <el-radio v-for="(item,index) in roleList" :key="index" :label="item.roleId">{{item.roleName}}</el-radio>

                    </el-radio-group>
                </el-form-item>
                <el-form-item style="margin-left:-80px;" class="confirmBtn">
                    <el-button @click="perfectInformation" type="success" style="width:100%;">确认绑定激活卡</el-button>
                </el-form-item>

            </el-form>
        </div>
        <div class="text-s-size numberColor activationTitle m-auto">
            *遇到错误请联系客服：400-0127-985
        </div>
    </div>
</template>
<script>
    import {message} from 'element-ui'
    import {
        activePost,
        commitBind,
        jhClassRoomDownMenu,
        jhGradeDownMenu,
        jhProvinceDownMenu,
        jhSchoolDownMenu,
        jhTeacherRoleDownMenu
    } from "../../../config";
    import {setSessionStore} from "../../../assets/static/global/global";
    export default{
        name: "activation",
        data(){
            var checkName=(rule,value,callback)=>{
                let nameZz= /^[a-zA-Z\u4E00-\u9FA5\uf900-\ufa2d·s]{2,20}$/;
                if(!value){
                    return callback(new Error('姓名不能为空'));
                }else if(!nameZz.test(value)){
                    return callback(new Error('姓名格式不正确'))
                }else{
                    callback();
                }
            };
            var checkRole=(rule,value,callback)=>{
                if(!value&&this.isTeacher){
                    return callback(new Error('未选择教师角色'));
                }else{
                    callback();
                }
            };
            var checkGrade=(rule,value,callback)=>{
                if(!value&&this.perfectData.roleId!=='1'&&!this.isTeacher){
                    return callback(new Error('未选择年级'))
                }else{
                    callback();
                }
            };
            var checkClass=(rule,value,callback)=>{
                if(!value&&(this.perfectData.roleId!=='1'&&this.perfectData.roleId!=='2'&&this.classList.length>0)){
                    return callback(new Error('未选择班级'))

                }else{
                    callback();
                }
            };
            return{
                radioRole:0,
                //传递提示弹窗相关配置
                modelObj:{
                    title:'',
                    width:'300px',
                    center:true
                },
                provinceDisabled:false,
                schoolDisabled:false,
                gradeDisabled:false,
                dialogShow:false,
                listTypeInfo:[],
                //判断是否是教师
                isTeacher:true,
                perfectData:{
                    realName:'',
                    provinceId:'',
                    schoolId:'',
                    roleId:'',
                    gradeId:'',
                    classId:''
                },
                rulesPerfectData:{
                    realName:[
                        {required:true,validator:checkName,trigger:'blur'}
                    ],
                    provinceId:[
                        {required:true,message:'未选择省份',trigger:'blur'}
                    ],
                    schoolId:[
                        {required:true,message:'未选择学校',trigger:'blur'}
                    ],
                    roleId:[
                        {required:true,validator:checkRole,trigger:'blur'}
                    ],
                    gradeId:[
                        {required:true,validator:checkGrade,trigger:'blur'}
                    ],
                    classId:[
                        {required:true,validator:checkClass,trigger:'blur'}
                    ]
                },
                active:1,
                className:'',
                labelWidth:'',
                provinceList:[],
                schoolList:[],
                roleList:[],
                gradeList:[],
                classList:[],
                datajh:{
                    jhm:'',
                    jhkPwd:''
                },
                rules:{
                    jhm:[
                        {required:true,message:'请输入激活卡号',trigger:"blur"}
                    ],
                    jhkPwd:[
                        {required:true,message:'请输入激活卡密码',trigger:'blur'}
                    ]
                },
                fieldList: [
                    { label: '',placeholderValue:'请输入学校下发的激活卡卡号', className:'largeHeight', value: 'jhm', type: 'input', required: true },
                    { label: '',size:'',placeholderValue:'请输入激活卡密码', value: 'jhkPwd', type: 'input',className:'settingW-100 largeHeight',required:true},
                    { label: '',name:'确认绑定',size:'',placeholderValue:'', event:'confirmBind', submitType:'form', buttonType:'primary', type: 'button',className:'settingW-100 largeHeight' },
                    { label: '',name:'没有激活卡卡号,去购买',size:'',placeholderValue:'', event:'goBuy', submitType:'',  type: 'button',className:'settingW-100 largeHeight' },
                ],
                memberCardId:'',
                stId:''
            }
        },
        mounted(){
           this.searchProvinceList();
           this.searchGrade();
        },
        methods:{
            //选择职位
            tapRadio(){
                console.log(this.perfectData.roleId);
                if(this.perfectData.roleId==='1'){
                    this.perfectData.gradeId='';
                    this.perfectData.classId='';

                }else if(this.perfectData.roleId==='2'){
                    this.perfectData.classId='';
                }
            },
            //关闭弹窗
            closeDialog(){
                this.dialogShow=false;
            },
            //触发学校值
            selectSchoolTap(){
                this.perfectData.gradeId='';
                this.perfectData.classId='';
                if(this.perfectData.schoolId!==''&&this.perfectData.gradeId!==''){
                    this.searchClassroomList();
                }
            },
            //选择年级
            selectGrade(){
                if(this.perfectData.gradeId!==''&&this.perfectData.schoolId!==''){
                    this.perfectData.classId='';
                    this.searchClassroomList();
                }
            },

            //选择学校
            selectSchool(){
              if(this.perfectData.provinceId===''){
                  message({
                      message:'请先选择省份',
                      type:'warning',
                      offset:300
                  })
              }
            },
            goBuy(){
                this.$router.push('/login/cardBuy');
            },
            //根据激活码和账号
            async confirmBind(allData){
                let result=await activePost(this.datajh.jhm,this.datajh.jhkPwd);
                if(result.status){
                    this.provinceDisabled=false;
                    this.schoolDisabled=false;
                    this.gradeDisabled=false;
                    this.active=2;
                    this.isTeacher=result.data.isTeacher;
                    if(this.isTeacher){
                        this.searchRoleList();
                    }
                    this.memberCardId=result.data.memberCardId;
                    this.stId=result.data.stId;
                    if(result.data.provinceId!==''){
                        this.perfectData.provinceId=result.data.provinceId;
                        this.provinceDisabled=true;
                        this.searchSchoolList();
                        if(result.data.schoolId!==''){
                            this.perfectData.schoolId=result.data.schoolId;
                            this.schoolDisabled=true;
                        }
                    }
                    if(result.data.graduateYear!==0){
                        this.gradeDisabled=true;
                        this.perfectData.gradeId=result.data.graduateYear;
                        this.searchClassroomList();
                    }
                }
            },
            //查出省份列表
            async searchProvinceList(){
                let result=await jhProvinceDownMenu();
                if(result.status){

                    this.provinceList=result.data;
                }
            },
            //查出学校
            async searchSchoolList(){
              let result=await jhSchoolDownMenu(this.perfectData.provinceId);
              if(result.status){
                  this.schoolList=result.data;
              }
            },
            //查出年级下拉
            async searchGrade(){
                let result=await jhGradeDownMenu();
                if(result.status){
                    this.gradeList=result.data;
                }
            },
            //查出老师角色下拉列表
            async searchRoleList(){
                let result=await jhTeacherRoleDownMenu();
                if(result.status){
                    this.roleList=result.data;
                }
            },
            //班级下拉菜单
            async searchClassroomList(){
              let result=await jhClassRoomDownMenu(this.perfectData.schoolId,this.perfectData.gradeId);
              if(result.status){
                  this.classList=result.data;
                  console.log(this.classList);
              }
            },
            //完善信息
            perfectInformation(){

                this.$refs['perfectInfo'].validate(async (valid)=>{
                    if(valid){

                        let result=await commitBind(this.isTeacher,this.memberCardId,this.stId,this.perfectData.provinceId,this.perfectData.schoolId,this.perfectData.gradeId,this.perfectData.classId,this.perfectData.realName,this.perfectData.roleId);
                        if(result.status){
                            this.dialogShow=true;
                            setTimeout(()=>{
                                this.dialogShow=false;
                                setSessionStore('notActInto','zhi');
                                this.$router.push('/studentAndTeacherPlatform?xiu=la');
                            },1000)
                        }else{

                        }
                    }
                })
            }
        }
    }
</script>
<style lang="scss" >
    .activations{
        >.el-dialog{
            border-radius: 20px!important;
            background: linear-gradient(45deg,#091039,transparent)!important;
        }
    }

    .activation{

        .secondForm{
            width:411px;
            margin: 0 auto;
            .confirmBtn{
                .el-form-item__content{
                    width:392px!important;
                }
            }
            .el-form-item__content{
                width:310px!important;
            }
            .el-select{
                width: 100%;
            }
        }
    }
</style>
<style lang="scss" scoped>


    .activation{
        padding-top:50px;
        $commonWidth:400px;
        $defaultColor:#666666;

        &Title{
            width:$commonWidth;

            .left{
                color:#00a1ff;

                width:90px;
            }

            .right{
                color:$defaultColor;
            }
        }
    }

</style>
